import { Add } from 'iconsax-react';

import { Button } from '@src/design-system/button';

import { CreateReminderDialog } from './create-reminder-dialog';

export function CreateReminderTriggerButton() {
  return (
    <CreateReminderDialog variant='bulk'>
      <Button
        type='button'
        size='sm'
        className='shrink-0 gap-2 rounded-xl'
      >
        <Add size={18} />
        New Reminder
      </Button>
    </CreateReminderDialog>
  );
}
